import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { HospitalStatistics } from '@/components/statistics/HospitalStatistics';

/**
 * Statistics Page - displays comprehensive hospital statistics
 * Including patient registrations, procedure statistics, and performance metrics
 */
export const StatisticsPage: React.FC = () => {
  return (
    <MainLayout>
      <HospitalStatistics />
    </MainLayout>
  );
};